import { useTranslation } from 'react-i18next'

import Button from '../../../../Button'
import Text from '../../../../Text'
import { QA_NAME_PHASE_STRIP_RETRY } from '../../RentalPortalPhaseBar.constants'

import * as styles from './PhaseStripError.module.css'

import RefreshIcon from '../../../../../icons/refresh.svg'

function PhaseStripError({ onRetry }) {
  const { t } = useTranslation()

  return (
    <div className={styles.PhaseStripError}>
      <Text isSecondary className={styles.text}>
        {t('RentalPortal.PhaseStripErrorKey')}
      </Text>
      <Button.Flat
        beforeIconProps={{ Icon: RefreshIcon }}
        qaName={QA_NAME_PHASE_STRIP_RETRY}
        onClick={onRetry}
      >
        {t('RentalPortal.PhaseStripRetryBtnKey')}
      </Button.Flat>
    </div>
  )
}

export default PhaseStripError
